import { ApolloQueryResult } from '@apollo/client';
import React from 'react';
import BillingProfilesTable from './billing-profiles-table';
import { CommerceAddress, Maybe, PaymentMethod } from '@css-xp/graphtypes';

interface InvoiceGroupsTabProps {
  label: string;
  disabled?: boolean;
  transactionAccountId?: string;
  billToAddress?: CommerceAddress | null;
  availablePaymentMethods?: Maybe<Maybe<PaymentMethod>[]> | undefined;
  onComplete?: () => Promise<ApolloQueryResult<unknown>>;
  updatePaymentMethodLink?: string;
  termPaymentStatus?: Maybe<string> | null;
}

const InvoiceGroupsTab = ({
  transactionAccountId,
  onComplete,
  billToAddress,
  availablePaymentMethods,
  updatePaymentMethodLink,
  termPaymentStatus,
}: InvoiceGroupsTabProps) => {
  return (
    <div className="invoice-groups-tab" data-testid="transaction-account-invoice-groups">
      <BillingProfilesTable
        transactionAccountId={transactionAccountId}
        onComplete={onComplete}
        billToAddress={billToAddress}
        availablePaymentMethods={availablePaymentMethods}
        updatePaymentMethodLink={updatePaymentMethodLink}
        termPaymentStatus={termPaymentStatus}
      />
    </div>
  );
};

export default InvoiceGroupsTab;
